import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";

export default function EditablePlugin({ uneditable }) {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    editor.setEditable(!uneditable);
  }, [editor, uneditable]);
  return null;
}
